<template>
  <main class="website-main">
    <div class="gradient-top">
      <section
        v-if="section1Title && section1Content"
        class="about-me-detail"
      >
        <div>
          <div>
            <article class="default-text">
              <h1>{{ section1Title }}</h1>
              <div v-html="section1Content" />
            </article>
          </div>
          <div>
            <div class="shape">
              <v-img-about-me-photo />
            </div>
          </div>
        </div>
      </section>
      <section
        v-if="section2Title && section2Content"
        class="default-section"
      >
        <div>
          <h2>{{ section2Title }}</h2>
          <article>
            <div v-html="section2Content" />
          </article>
          <div class="d-flex justify-center">
            <v-btn
              href="/kontakt"
              variant="flat"
              size="x-large"
              color="#d90d83"
            >
              Mám zájem
            </v-btn>
          </div>
        </div>
      </section>
    </div>
    <v-section-faq category="services" />
    <div class="gradient-bottom">
      <section
        v-if="section3Title && section3Content"
        class="default-section"
      >
        <div>
          <h2>{{ section3Title }}</h2>
          <article>
            <div v-html="section3Content" />
          </article>
        </div>
      </section>
      <section class="form-separate">
        <div>
          <v-form-contact />
        </div>
      </section>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import VImgAboutMePhoto from '../components/v-img/VImgAboutMePhoto.vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'
import VFormContact from '../components/v-form/VFormContact.vue'
import { Microsite } from '../interfaces/Microsite'
import VSectionFaq from '../components/v-section/VSectionFaq.vue'

const props = defineProps<{
  microsite: Microsite
}>()

const micrositeStore = useMicrositeStore()

onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
})

const store = useMicrositeStore()

const microsite = computed(() => {
  return store.microsite
})

const section1Title = computed(() => {
  return microsite.value?.servicesSection1Title
})

const section1Content = computed(() => {
  return microsite.value?.servicesSection1Content
})

const section2Title = computed(() => {
  return microsite.value?.servicesSection2Title
})

const section2Content = computed(() => {
  return microsite.value?.servicesSection2Content
})

const section3Title = computed(() => {
  return microsite.value?.servicesSection3Title
})

const section3Content = computed(() => {
  return microsite.value?.servicesSection3Content
})
</script>
